import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { ImageWithFallback } from '~/hooks/common/ui/useImageWithFallback';
import { ImageType } from './hooks/useGetImages';
import { ImageWrapper, Vehicle } from './WhyBuy.styles';

type OwnProps = {
  image?: ImageWithFallback<ImageType>;
};

export default function WhyBuyVehicleImage({ image }: OwnProps) {
  const { make = '', model = '', trim = '', year = 0 } = useGetVehicleDetails();

  return image ? (
    <ImageWrapper>
      <Vehicle
        alt={`${year} ${make} ${model} ${trim}`.trim()}
        data-testid="why-buy-vehicle"
        src={image.url}
      />
    </ImageWrapper>
  ) : null;
}
